<template>
    <div>
        <b-table
            ref="reportDelivery"
            show-empty
            responsive
            :items="notificationList"
            :fields="notificationLisFields"
            :busy="busy"
            selectable
            select-mode="multi"
            class="scroll-bar-pop text-center"
            empty-text="ไม่มีข้อมูลผู้ใช้"
            empty-filtered-text="ไม่พบข้อมูลที่ต้องการค้นหา"
        >
            <template slot="logo" slot-scope="data">
                <img :src="data.item.expressLogo" alt="" style="width: 48px; height: 32px">
            </template>
            <template slot="noticeAddress" slot-scope="data">
                <span class="fs-12">{{ data.item.pickUpAddress }}</span>
                <span
                    v-if="data.item.expressCode === 'FLASH' || data.item.expressCode === 'THAIPOST' || data.item.expressCode === 'ECO'  "
                    class="fs-12">-</span>
            </template>
            <template slot="Deadline" slot-scope="data">
                                        <span
                                            class="fs-12"
                                            v-if="data.item.expressCode === 'FLASH'"
                                        >เข้ารับภายในวัน เรียกรถก่อน 14:00 น.</span>
                <span
                    class="fs-12"
                    v-if="data.item.expressCode === 'THAIPOST'"
                >กรุณาติดต่อสาขา ไปรษณีย์ในพื้นที่ของท่าน</span>
                <span
                    class="fs-12"
                    v-if="data.item.expressCode === 'NINJA'"
                >เข้ารับภายในวัน ทำรายการก่อน 12:00 น.</span>
                <span
                    class="fs-12"
                    v-if="data.item.expressCode === 'SCG'"
                >เข้ารับภายในวัน ทำรายการก่อน 13:00 น.</span>
                <span
                    class="fs-12"
                    v-if="data.item.expressCode === 'SCG8'"
                >เข้ารับภายในวัน ทำรายการก่อน 13:00 น.</span>
                <span
                    class="fs-12"
                    v-if="data.item.expressCode === 'SCG15'"
                >เข้ารับภายในวัน ทำรายการก่อน 13:00 น.</span>
                <span
                    class="fs-12"
                    v-if="data.item.expressCode === 'ECO'"
                >กรุณาติดต่อสาขา ไปรษณีย์ในพื้นที่ของท่าน</span>
                <span
                    class="fs-12"
                    v-if="data.item.expressCode === 'DHL'"
                >เข้ารับภายในวัน ทำรายการก่อน 11:00 น.</span>
                <span
                    class="fs-12"
                    v-if="data.item.expressCode === 'BEST'"
                >เข้ารับภายในวัน ทำรายการก่อน 12:00 น.</span>
            </template>
            <template slot="tips" slot-scope="data">
                                        <span
                                            class="fs-12"
                                            v-if="data.item.expressCode === 'FLASH'"
                                        >1436 </span>
                <span
                    class="fs-12"
                    v-if="data.item.expressCode === 'THAIPOST'"
                >02-831-3131 </span>
                <span
                    class="fs-12"
                    v-if="data.item.expressCode === 'NINJA'"
                >02-026-1499 </span>
                <span
                    class="fs-12"
                    v-if="data.item.expressCode === 'SCG'"
                >02-239-8999 </span>
                <span
                    class="fs-12"
                    v-if="data.item.expressCode === 'SCG8'"
                >02-239-8999 </span>
                <span
                    class="fs-12"
                    v-if="data.item.expressCode === 'SCG15'"
                >02-239-8999 </span>
                <span
                    class="fs-12"
                    v-if="data.item.expressCode === 'ECO'"
                >02-831-3131 </span>
                <span
                    class="fs-12"
                    v-if="data.item.expressCode === 'DHL'"
                >02-029-0999 </span>
                <span
                    class="fs-12"
                    v-if="data.item.expressCode === 'BEST'"
                >02-108-8000 </span>
            </template>
            <template slot="actions" slot-scope="data">
                <div style="display:flex;align-items:Center;justify-content: space-around;">

                    <!-- 通知状态 -->
                    <b-badge variant="status-parcel-danger"
                             v-if="data.item.isNotice === true && data.item.expressCode === 'FLASH'"
                    >已呼叫
                    </b-badge>
                    <b-badge variant="status-parcel-danger"
                             v-if="data.item.isNotice === true && data.item.expressCode == 'THAIPOST'"
                    >已呼叫
                    </b-badge>
                    <b-badge variant="status-parcel-danger"
                             v-if="data.item.isNotice === false && data.item.expressCode === 'FLASH'"
                    >未呼叫
                    </b-badge>
                    <b-badge variant="status-parcel-danger"
                             v-if="data.item.isNotice === false && data.item.expressCode == 'THAIPOST'"
                    >未呼叫
                    </b-badge>
                    <b-badge variant="status-parcel-danger"
                             v-if="data.item.pkgPrintedCount !== '0' && data.item.expressCode !== 'FLASH' && data.item.expressCode !== 'THAIPOST'&&data.item.expressCode !== 'ECO'"
                    >已呼叫
                    </b-badge>
                    <b-badge variant="status-parcel-danger"
                             v-if="data.item.pkgPrintedCount === '0' && data.item.expressCode !== 'FLASH'&& data.item.expressCode !== 'THAIPOST'&&data.item.expressCode !== 'ECO'"
                    >
                        已呼叫
                    </b-badge>
                    <div>
                        <button class="btn btn-sm btn-info px-3"
                            v-if="data.item.expressCode == 'FLASH'"
                                @click="showNoticeForm(data.item)"
                        >通知揽件
                        </button>
                        <button class="btn btn-sm btn-info px-3"
                            v-if="data.item.expressCode == 'THAIPOST'"
                                @click="showNoticeForm(data.item)"
                        >通知揽件
                        </button>
                        <span
                            class="fs-12"
                            v-if="data.item.expressCode == 'SCG8' ||data.item.expressCode == 'SCG15'">
                                                        提前一天通知揽件 当天 12 点前下单，明天揽件 当天 12 点后下单 2 天内揽件
                                                </span>
                        <span
                            class="fs-12"
                            v-if="data.item.expressCode !== 'FLASH' && data.item.expressCode !== 'THAIPOST'&& data.item.expressCode !== 'ECO'">
                                                    自动呼叫
                                                </span>
                    </div>
                </div>
            </template>
        </b-table>

        <b-modal
            centered
            hide-footer
            v-model="noticeDialogOptions.visible"
            :title="noticeDialogOptions.title"
            size="lg"
        >
            <div class="row">
                <div class="col-lg-12 py-4">
                    <b-form @submit="onSubmit">
                        <b-form-group
                            id="input-group-1"
                            label="快递员员工号："
                            label-for="input-1"
                        >
                            <b-form-input
                                id="input-1"
                                v-model="ruleForm.staffInfoId"
                                placeholder=""
                                required
                            ></b-form-input>
                        </b-form-group>
                        <h2>收货地址</h2>
                        <b-form-group
                            id="input-group-1"
                            label="姓名："
                            label-for="input-1"
                        >
                            <b-form-input
                                id="input-1"
                                disabled
                                v-model="ruleForm.name"
                                placeholder=""
                                required
                            ></b-form-input>
                        </b-form-group>
                        <b-form-group
                            id="input-group-1"
                            label="电话号码："
                            label-for="input-1"
                        >
                            <b-form-input
                                id="input-1"
                                v-model="ruleForm.phone"
                                placeholder=""
                                required
                            ></b-form-input>
                        </b-form-group>
                        <b-form-group
                            id="input-group-1"
                            label="行政区域："
                            label-for="input-1"
                        >
                            <b-form-input
                                id="input-1"
                                disabled
                                v-model="ruleForm.senderPct"
                                placeholder=""
                                required
                            ></b-form-input>
                        </b-form-group>
                        <b-form-group
                            id="input-group-1"
                            label="详细地址："
                            label-for="input-1"
                        >
                            <b-form-input
                                id="input-1"
                                v-model="ruleForm.address"
                                placeholder=""
                                required
                            ></b-form-input>
                        </b-form-group>
                        <b-form-group
                            id="input-group-1"
                            label="揽件数量："
                            label-for="input-1"
                        >
                            <b-form-input
                                id="input-1"
                                type="number"
                                v-model="ruleForm.count"
                                placeholder=""
                                required
                            ></b-form-input>
                        </b-form-group>
                        <b-form-group
                            v-if="ruleForm.expressCode === 'THAIPOST'"
                            id="input-group-1"
                            label="预期预约时间："
                            label-for="input-1">
                            <input
                                type="datetime-local"
                                placeholder="dd/mm/yyyy hh:mm:ss"
                                class="form-control"
                                v-model="ruleForm.estimateTime"
                            />
                        </b-form-group>
                        <b-form-group
                            id="input-group-1"
                            label="备注："
                            label-for="input-1"
                        >
                            <b-form-textarea
                                id="input-1"
                                rows="3"
                                max-rows="6"
                                v-model="ruleForm.remark"
                                placeholder=""
                            ></b-form-textarea>
                        </b-form-group>

                        <p style="color:#ff4d4f;font-size:12px;" v-if="ruleForm.expressCode === 'FLASH'">
                            注意：Flash 通知揽件支持修改详细地址，但仅对本次通知有效，<br>
                            如需修改快递公司的揽件地址，请到商家中心中提交地址修改请求。</p>
                    </b-form>
                </div>
            </div>
            <div class="d-flex justify-content-center mt-4">
                <b-button
                    class="px-5"
                    variant="secondary"
                    @click="closeModal()"
                >
                    ยกเลิก
                </b-button>
                <b-button
                    class="px-5"
                    type="submit"
                    variant="primary"
                >
                    ยืนยัน
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
import {noticeCourierV2, queryDayAnalysisList} from "@/api/noticePackage";
import moment from "moment/moment";

export default {
    data() {
        return {
            busy: false,
            notificationList: [],
            notificationLisFields: [
                {key: 'logo', label: 'LOGO', sortable: true},
                {key: 'noticeAddress', label: '揽件地址', sortable: true},
                {key: 'Deadline', label: '揽件截止时间', sortable: true},
                {key: 'tips', label: '提示', sortable: true},
                {key: 'actions', label: '操作'}
            ],
            ruleForm: {
                name: '',
                phone: '',
                senderPct: '',
                address: '',
                remark: '',
                count: '',
                pno: '',
                senderCity: '',
                senderDistrict: '',
                senderProvince: '',
                senderPostcode: '',
                expressCode: '',
                staffInfoId: '',
                estimateTime:'',
            },
            noticeDialogOptions: {
                visible: false,
                title: '指定快递员揽收',
            },
        }
    },
    mounted() {
        this.queryDayAnalysisList()
    },
    methods: {
        onSubmit(evt) {
            evt.preventDefault()
            let params = {
                estimateParcelNumber: this.ruleForm.count,
                expressCode: this.ruleForm.expressCode,
                remark: this.ruleForm.remark,
                srcCityName: this.ruleForm.senderCity,
                srcDetailAddress: this.ruleForm.address,
                srcDistrictName: this.ruleForm.senderDistrict,
                srcName: this.ruleForm.name,
                srcPhone: this.ruleForm.phone,
                srcPostalCode: this.ruleForm.senderPostcode,
                pno: this.ruleForm.pno,
                srcProvinceName: this.ruleForm.senderProvince,
                pickupStaffInfoId: this.ruleForm.staffInfoId,
                estimateTime:this.ruleForm.estimateTime
            };
            noticeCourierV2(params).then(res => {
                // 然后去通知揽件列表
                this.queryDayAnalysisList()
            }).finally(() => {
                this.noticeDialogOptions.visible = false
            })
        },
        closeModal() {
            this.noticeDialogOptions.visible = false
        },
        showNoticeForm(item) {
            let data = this.$store.state.userInfo
            this.ruleForm.name = data.agentName
            this.ruleForm.phone = data.mobile
            this.ruleForm.senderPct = data.district +
                '-' +
                data.city +
                '-' +
                data.province +
                '-' +
                data.postCode
            this.ruleForm.senderCity = data.city
            this.ruleForm.senderDistrict = data.district
            this.ruleForm.senderProvince = data.province
            this.ruleForm.senderPostcode = data.postCode
            this.ruleForm.address = data.address
            this.ruleForm.count = item.pkgPrintedCount
            this.ruleForm.expressCode = item.expressCode
            this.noticeDialogOptions.visible = true
        },
        queryDayAnalysisList() {
            this.busy = true
            queryDayAnalysisList({
                agentId: this.$store.state.loginUser.agentId,
                date: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
            }).then(res => {
                console.log(res, 123123)
                this.notificationList = res.data
                this.busy = false
            }).finally(() => {
                this.busy = false
            })
        }
    },
}
</script>

<style scoped>

</style>
